export const MAX_INPUT_SYMBOLS_LENGTH = 1;
